export default __webpack_public_path__ + "static/media/ic_marker_origin.840621f0.svg";